export default __webpack_public_path__ + "static/media/1942.e7d387e1.png";